import { createPortal } from 'react-dom'
import * as React from 'react'
import classnames from 'classnames'

import cls from './GenericBtnModal.module.scss'

class GenericBtnModal extends React.Component {
  static defaultProps = {
    classNames: {},
    showMobileCloseButton: true,
  }

  state = {
    modalIsVisible: true,
    modalBackdropIsVisible: true,
    container: null,
  }

  componentDidMount() {
    const container = document.createElement('div')
    document.body.appendChild(container)
    this.setState({ container })
  }

  componentWillUnmount() {
    const { container } = this.state
    if (container) {
      container.remove()
    }
  }

  unhideModal = () => {
    this.setState({
      modalIsVisible: true,
      modalBackdropIsVisible: true,
    })
  }

  closeModal = () => {
    const { modalClosed } = this.props

    this.setState({
      modalIsVisible: false,
    })

    setTimeout(() => {
      this.setState({
        modalBackdropIsVisible: false,
      })
      if (typeof modalClosed === 'function') {
        modalClosed()
      }
      this.unhideModal()
    }, 450)
  }

  render() {
    const {
      showModal,
      title,
      description,
      btnText,
      modalImg,
      modalBtnFunction,
      children,
      classNames,
      showMobileCloseButton,
    } = this.props

    const { modalBackdropIsVisible, modalIsVisible, container } = this.state

    if (!container) {
      return null
    }

    if (!showModal) {
      return null
    }

    return createPortal(
      <div
        className={classnames({
          [cls.genericBtnModalBackdrop]: modalBackdropIsVisible,
          hidden: !modalBackdropIsVisible,
        })}
        onClick={this.closeModal}
      >
        <div
          className={classnames(
            cls.genericBtnModal,
            {
              [cls.genericBtnModalOut]: !modalIsVisible,
            },
            classNames.modal
          )}
          onClick={e => e.stopPropagation()}
        >
          <div className={cls.genericBtnModalCloseBtn} onClick={this.closeModal}>
            ✕
          </div>
          {modalImg && (
            <div
              className={classnames(cls.genericBtnModalImageContainer, classNames.imageContainer)}
            >
              <img
                className={classnames(cls.genericBtnModalImg, classNames.image)}
                src={modalImg}
                alt=""
              />
            </div>
          )}
          <div className={classnames(cls.genericBtnModalContent, classNames.content)}>
            {title && (
              <h1 className={classnames(cls.genericBtnModalHeader, classNames.header)}>{title}</h1>
            )}
            {description ? (
              <p className={cls.genericBtnModalEventDescription}>{description}</p>
            ) : children ? (
              children
            ) : null}
            <div className={cls.genericBtnModalButtonContainer}>
              {btnText && (
                <button
                  data-cy="generic-modal-btn"
                  className={cls.genericBtnModalBtn}
                  onClick={modalBtnFunction}
                >
                  {btnText}
                </button>
              )}
              {showMobileCloseButton && (
                <button
                  className={cls.genericBtnModalMobileClose}
                  onClick={this.closeModal}
                  type="button"
                >
                  close
                </button>
              )}
            </div>
          </div>
        </div>
      </div>,
      container
    )
  }
}

export default GenericBtnModal
